import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bill, useAuth } from "../../../../hooks/AuthContext";
import { showToast } from "../../../../components/CustomToast";
import api from "../../../../services/api";
import { Modal } from "../../../../components/Modal";
import { BillPaymentDetails } from "../../../../components/BillPaymentDetails";
import { currencyValue } from "../../../../components/UsersProfile/mock";
import { Container, Wrapper } from "./style";
import { ClosureItem } from "../../../../components/ClosureItem";
import { i18n } from "../../../../localization/i18n";
import { roles } from "../../../../utils/constants";
import { Loader } from "../../../../components/Loader";
import { format } from "date-fns";

interface IOrdersClosure {
  sum: string;
  total: number;
  totalCourtesy: string;
  totalNotPaid: string;
  totalPaid: string;
}

export default function MonthClosure() {
  const { user, reloadUser, licenseeBills, currency } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { setNavigationAction } = useAuth();

  const [filterStartDate, setFilterStartDate] = useState<Date>();
  const [filterEndDate, setFilterEndDate] = useState<Date>();
  const [previousFilterStartDate, setPreviousFilterStartDate] =
    useState<Date>();
  const [previousFilterEndDate, setPreviousFilterEndDate] = useState<Date>();
  const [orders, setOrders] = useState<IOrdersClosure>();
  const [previousOrders, setPreviousOrders] = useState<IOrdersClosure>();
  const [ordersAsProvider, setOrdersAsProvider] = useState<IOrdersClosure>();
  const [previousOrdersAsProvider, setPreviousOrdersAsProvider] =
    useState<IOrdersClosure>();
  const [licenseeBill, setLicenseeBill] = useState<Bill>();

  const [openCardSelectModal, setOpenCardSelectModal] = useState(false);

  function toggleCardSelectModal() {
    setOpenCardSelectModal(!openCardSelectModal);
  }

  async function getDate() {
    const dataAtual = new Date();
    const ano = dataAtual.getFullYear();
    const mes = dataAtual.getMonth();
    if (new Date().getDate() > 25) {
      const filterStartDate = new Date(ano, mes, 26);
      const filterEndDate = new Date(ano, mes + 1, 26);
      const previousFilterStartDate = new Date(ano, mes - 1, 26);
      const previousFilterEndDate = new Date(ano, mes, 26);
      setFilterEndDate(filterEndDate);
      setFilterStartDate(filterStartDate);
      setPreviousFilterEndDate(previousFilterEndDate);
      setPreviousFilterStartDate(previousFilterStartDate);
      return {
        filterEndDate,
        filterStartDate,
        previousFilterEndDate,
        previousFilterStartDate,
      };
    } else {
      const filterStartDate = new Date(ano, mes - 1, 26);
      const filterEndDate = new Date(ano, mes, 26);
      const previousFilterStartDate = new Date(ano, mes - 2, 26);
      const previousFilterEndDate = new Date(ano, mes - 1, 26);
      setFilterEndDate(filterEndDate);
      setFilterStartDate(filterStartDate);
      setPreviousFilterEndDate(previousFilterEndDate);
      setPreviousFilterStartDate(previousFilterStartDate);
      return {
        filterEndDate,
        filterStartDate,
        previousFilterEndDate,
        previousFilterStartDate,
      };
    }
  }

  function formatDate(date: Date) {
    return format(date, "dd/MM/yyyy");
  }

  async function getOrders() {
    try {
      await getDate().then((response) => {
        api
          .get(
            `/orders/user?from=${response.filterStartDate?.toJSON()}&to=${response.filterEndDate?.toJSON()}`
          )
          .then((response) => {
            setOrders({
              sum: response.data.sum,
              total: response.data.total,
              totalCourtesy: response.data.totalCourtesy,
              totalNotPaid: response.data.totalNotPaid,
              totalPaid: response.data.totalPaid,
            });
          });
      });
    } catch (err) {
      showToast({
        type: "error",
        message: "Não foi possivel carregar as informações de pedido",
      });
    }
  }

  async function getPreviousOrders() {
    try {
      await getDate().then((response) => {
        api
          .get(
            `/orders/user?from=${response.previousFilterStartDate?.toJSON()}&to=${response.previousFilterEndDate?.toJSON()}`
          )
          .then((response) => {
            setPreviousOrders({
              sum: response.data.sum,
              total: response.data.total,
              totalCourtesy: response.data.totalCourtesy,
              totalNotPaid: response.data.totalNotPaid,
              totalPaid: response.data.totalPaid,
            });
          });
      });
    } catch (err) {
      showToast({
        type: "error",
        message: "Não foi possivel carregar as informações de pedido",
      });
    }
  }

  async function getPreviousOrdersAsProvider() {
    try {
      await getDate().then((response) => {
        api
          .get(
            `/orders/user?from=${response.previousFilterStartDate?.toJSON()}&to=${response.previousFilterEndDate?.toJSON()}&as_provider=true`
          )
          .then((response) => {
            setPreviousOrdersAsProvider({
              sum: response.data.sum,
              total: response.data.total,
              totalCourtesy: response.data.totalCourtesy,
              totalNotPaid: response.data.totalNotPaid,
              totalPaid: response.data.totalPaid,
            });
          });
      });
    } catch (err) {
      showToast({
        type: "error",
        message: "Não foi possivel carregar as informações de pedido",
      });
    }
  }

  async function getOrdersAsProvider() {
    try {
      await getDate().then((response) => {
        api
          .get(
            `/orders/user?from=${response.filterStartDate?.toJSON()}&to=${response.filterEndDate?.toJSON()}&as_provider=true`
          )
          .then((response) => {
            setOrdersAsProvider({
              sum: response.data.sum,
              total: response.data.total,
              totalCourtesy: response.data.totalCourtesy,
              totalNotPaid: response.data.totalNotPaid,
              totalPaid: response.data.totalPaid,
            });
          });
      });
    } catch (err) {
      showToast({
        type: "error",
        message: "Não foi possivel carregar as informações de pedido",
      });
    }
  }

  useEffect(() => {
    Promise.all([
      getOrders(),
      getOrdersAsProvider(),
      getPreviousOrders(),
      getPreviousOrdersAsProvider(),
    ]);
  }, []);

  useEffect(() => {
    if (
      orders &&
      ordersAsProvider &&
      previousOrders &&
      previousOrdersAsProvider
    ) {
      setLoading(false);
    }
  }, [orders, ordersAsProvider, previousOrders, previousOrdersAsProvider]);

  useEffect(() => {
    setLicenseeBill(
      licenseeBills.find(
        (bill) =>
          bill.referring_period ===
          `${new Date(previousFilterEndDate as Date).getMonth() + 1}/${new Date(
            previousFilterEndDate as Date
          ).getFullYear()}`
      )
    );
  }, [previousFilterEndDate, user, licenseeBills]);

  useEffect(() => {
    setNavigationAction({
      hasButton: false,
      description: i18n.t("sidebar.financial")
    });
  }, []);

  return (
    <>
      <Modal
        open={openCardSelectModal}
        onRequestClose={toggleCardSelectModal}
        modalWidth={500}
      >
        <BillPaymentDetails
          bill={licenseeBill}
          reloadUser={reloadUser}
          onHandleCancel={toggleCardSelectModal}
          totalBillValue={(
            (Number(previousOrders?.totalNotPaid)) -
            Number(licenseeBill ? licenseeBill?.paid_ammount : 0)
          ).toFixed(2)}
          closure_date={previousFilterEndDate ?? new Date()}
          currency={currency?.code ?? currencyValue.BRL}
        />
      </Modal>
      {!loading ? (
        <Container>
          <Wrapper>
            <ClosureItem
              title={`${i18n.t("userProfile.actualClosure")} (${currency?.code
                })`}
              description={`${i18n.t("userProfile.descriptions.closure")}`}
              period={`${formatDate(filterStartDate as Date)} - ${formatDate(
                filterEndDate as Date
              )}`}
              help={`${i18n.t("userProfile.descriptions.closurePopover")}`}
              value={
                Number(orders?.totalNotPaid)
              }
              onClick={() => {
                navigate({
                  pathname: `/${user.role.toLocaleLowerCase()}/orders/closure`,
                  search: `?from=${formatDate(
                    filterStartDate as Date
                  )}&to=${formatDate(filterEndDate as Date)}`,
                });
              }}
            />
            <ClosureItem
              currency={currency?.code}
              bill={licenseeBill}
              closurePeriod={previousFilterEndDate}
              acceptPayment={
                !licenseeBill && (previousFilterEndDate as Date) <= new Date()
              }
              onHandlePayBill={toggleCardSelectModal}
              title={`${i18n.t("userProfile.previousClosure")} (${currency?.code
                })`}
              description={`${i18n.t("userProfile.descriptions.closure")}`}
              period={`${formatDate(
                previousFilterStartDate as Date
              )} - ${formatDate(previousFilterEndDate as Date)}`}
              help={`${i18n.t("userProfile.descriptions.closurePopover")}`}
              value={(
                Number(previousOrders?.totalNotPaid)
              ).toFixed(2)}
              onClick={() => {
                navigate({
                  pathname: `/${user.role.toLocaleLowerCase()}/orders/closure`,
                  search: `?from=${formatDate(
                    previousFilterStartDate as Date
                  )}&to=${formatDate(previousFilterEndDate as Date)}`,
                });
              }}
            />
            {user.role === roles.licensee && (
              <ClosureItem
                title={`${i18n.t("orders.as_provider")}`}
                description={`${i18n.t("userProfile.descriptions.fixPoint")}`}
                help={`${i18n.t("userProfile.descriptions.fixPointPopover")}`}
                value={ordersAsProvider?.total ?? 0}
                onClick={() => {
                  navigate({
                    pathname: `/orders/as_provider`,
                  });
                }}
              />
            )}
            <ClosureItem
              title={`${i18n.t("userProfile.ordersMade")}`}
              description={`${i18n.t("userProfile.descriptions.ordersMade")}`}
              value={orders?.total ?? 0}
            />
          </Wrapper>
        </Container>
      ) : (
        <Container>
          <Loader />
        </Container>
      )}
    </>
  );
}
